<div *ngIf="busy">
  Please wait...
</div>
<div *ngIf="!busy && !showpay" style="padding-top: 15px;">
  <div align="center" style="text-align:center;">
    <img src="/assets/trophy.jpg" height="200" />
    &nbsp;&nbsp;
    <img src="/assets/1st_tiebreak.jpg" height="200" />
  </div>
  <h3>2nd Annual Tiebreaker Tournament</h3>
  <h4>Sunday, November 13, 2022 11:45pm-5pm at Swim and Racquet Club</h4>
  <h5>Cost: $35 (+court fees <u>if you are not a member</u>)</h5>
  <h5>Prizes: Winner - $50 & Trophy, Runner Up - $30, 3rd place - $20</h5>
  <h5>We will supply the balls, snacks, and trophy. We will only take only TEN players total. The first ten to sign up <u>and</u> pay. After that, email me for a waiting list
    in case a player can not play.
  </h5>
  <!-- <form [formGroup]="newLadderForm" style="padding-top: 15px;"> -->
  <!-- <input type="hidden" formControlName="ladderId" value="2022-1-TIEBREAK" />
    <input type="hidden" formControlName="levelId" value="5" />  THIS HAS TO BE AN INT -->
  <br /><br />
  <label><input type="checkbox" #agree />&nbsp;I agree to the rules!!!</label>
  <br /><br />
  <button (click)="submit()" [disabled]="!agree.checked">Sign Me Up! I agree!</button>
  <br /><br />
  <b>Rules (read these carefully):</b>
  <ul>
    <li>
      <u>You must be here to have fun!</u> You must have good sportsmanship. Be happy for other players if they get a lucky shot,
      hit the net and drop over, skip off a line, or get pulled in from the wind.
    </li>
    <li>Bring drinks, sunblock, towels, and food. It could be a LONG day with a LOT of tennis.</li>
    <li>You will play each player one time in a 10 point tiebreaker. Nine tiebreaks total.</li>
    <li>First player to 10 points wins. You do not need to win by 2. (ex. Final score can be 10-0 or 10-9 or anything in between)</li>
    <li>
      <u>You will collect score points throughout the day</u> and they will be added together for your total score
      (EVERY POINT, EVERY GAME, count towards your final score)
    </li>
    <li>
      We will have 4 courts. One can of balls will be left on each court and will remain for approx. half the day.
      We will then supply 4 new cans for the 2nd half of the day.
    </li>
    <li>
      On the first match of the day, you will get 10 minutes to warm up. Every other match of the day you can
      get up to 5 minutes to warm up. We will be strict about this because we only have four hours to get in 45 tiebreakers.
    </li>
    <li>
      To start a tiebreaker, one player flips their racquet and the other calls up/down. The winner chooses to serve or receive first,
      the other player chooses which side they want to start.
    </li>
    <li>Switch sides after every 6 points.</li>
    <li>
      <b>The winner has the most points at the end of the day.</b> In case of a tie, the two players tied will play a tiebreaker. If more than two
      players
      are tied, we will see who beat who in tournament play or flip a coin.
    </li>
    <li>
      <u>There will be no arguing line calls</u>. The player on the side where the ball lands makes the call. No question, no debate, no mark
      necessary. If multiple players complain about your lines calls, you will not be invited back next year. Error on the side of IN.
    </li>
    <li>Eric is here to have fun and watch some good tennis. He is not here to be a babysitter or referee or line judge.</li>
  </ul>
  <!-- </form> -->
</div>
<div *ngIf="!busy && showpay" style="padding-top: 15px;">
  <div align="center" style="text-align:center;">
    <img src="/assets/trophy.jpg" width="150" />
  </div>
  <h3>2nd Annual Tiebreaker Tournament</h3>
  <h4>November 13, 2022 11:45pm-5pm at Swim and Racquet Club</h4>
  <div>
    Please pay now - $35. This guarantees your spot in the tournament.
    Your registration does not count until you pay. Someone else may register and pay before you.
    <br />
    Paypal: elubin&#64;elubin.com
    <br />
    Venmo: &#64;elubincom (4-digits 9787)
    <br />
    Zelle: 561-213-7852
  </div>
</div>
